import { Key } from './constants';
/* FirstPart */
export const createOrderFirstPart = () => [Key.ORDER];
export const createDateIndexFirstPart = () => [Key.DATE_INDEX];
/**
 * @deprecated
 */
export const createBestByQuoteIndexFirstPart = () => [Key.BEST_BY_QUOTE_INDEX];
export const createActiveOrderIndexFirstPart = () => [Key.ACTIVE_INDEX];
export const createBestByQuoteActiveIndexFirstPart = () => [Key.BEST_BY_QUOTE_INDEX, Key.ACTIVE_INDEX];
export const createOrderByMakerIndexFirstPart = (user) => [Key.MAKER_INDEX, user];
export const createActiveOrderByMakerIndexFirstPart = (user) => [Key.ACTIVE_INDEX, Key.MAKER_INDEX, user];
export const createClosedIndexFirstPart = () => [Key.CLOSED_INDEX];
export const createUniquenessFirstPart = () => [Key.UNIQUENESS_CHECK]; //TODO: Add second element as a type of uniqueness
export const createL1TxInfoFirstPart = (user) => [Key.L1_TX_INFO, user];
/* Key */
export const createOrderKey = (orderId) => ({
    first_part: createOrderFirstPart(),
    second_part: [orderId],
});
export const createDateIndexKey = (timestamp, orderId) => ({
    first_part: createDateIndexFirstPart(),
    second_part: [Number.MAX_SAFE_INTEGER - timestamp, orderId],
});
export const createBestByQuoteIndexKey = (rate, orderId) => ({
    first_part: createBestByQuoteIndexFirstPart(),
    second_part: [rate.toString(16), orderId],
});
export const createActiveOrderIndexKey = (timestamp, orderId) => ({
    first_part: createActiveOrderIndexFirstPart(),
    second_part: [Number.MAX_SAFE_INTEGER - timestamp, orderId],
});
export const createBestByQuoteActiveIndexKey = (rate, orderId) => ({
    first_part: createBestByQuoteActiveIndexFirstPart(),
    second_part: [rate.toString(16), orderId],
});
export const createOrderByMakerIndexKey = (user, timestamp, orderId) => ({
    first_part: createOrderByMakerIndexFirstPart(user),
    second_part: [Number.MAX_SAFE_INTEGER - timestamp, orderId],
});
export const createActiveOrderByMakerIndexKey = (user, timestamp, orderId) => ({
    first_part: createActiveOrderByMakerIndexFirstPart(user),
    second_part: [Number.MAX_SAFE_INTEGER - timestamp, orderId],
});
export const createClosedIndexKey = (orderId) => ({
    first_part: createClosedIndexFirstPart(),
    second_part: [orderId],
});
export const createUniquenessKey = (data) => ({
    first_part: createUniquenessFirstPart(),
    second_part: data,
});
export const createBtcUtxoUniquenessKey = (data) => ({
    first_part: createUniquenessFirstPart(),
    second_part: [data.l1TxId, data.vout],
});
export const createL1TxKey = (timestamp, uniqueId, user) => ({
    first_part: createL1TxInfoFirstPart(user),
    second_part: [Number.MAX_SAFE_INTEGER - timestamp, uniqueId],
});
export const createIdIncrementIndexKey = () => ({
    first_part: [Key.INCREMENT_INDEX],
    second_part: [Key.INCREMENT_INDEX],
});
